import { useQuery } from "@tanstack/react-query";
import type { BdPayload } from "@shared/bdTracker";
import type { BdPeriod } from "@shared/bdPeriod";

/** Key prefix "coi-bd" is what every COI write invalidates. */
export function useBdTracker(period: BdPeriod, who: string, opts: { enabled?: boolean } = {}) {
  return useQuery<BdPayload>({
    queryKey: ["coi-bd", period, who],
    queryFn: async () => {
      const r = await fetch(`/api/cois/bd?${new URLSearchParams({ period, who })}`, { credentials: "include" });
      if (!r.ok) {
        const err = Object.assign(new Error((await r.json().catch(() => ({}))).error ?? "Failed to load the BD tracker"), { status: r.status });
        throw err;
      }
      return r.json();
    },
    enabled: opts.enabled ?? true,
    staleTime: 30_000,
    // Keep the last view on screen while another person or period loads.
    placeholderData: (prev) => prev,
    // A 400 is a stale ?who= and will not heal on retry; the page falls back to Everyone.
    retry: (n, e) => (e as { status?: number }).status !== 400 && n < 2,
  });
}
